import { motion } from "framer-motion";
import React, { useEffect, useState, useCallback } from "react";

export default function HeroSection() {
  const [showBackground, setShowBackground] = useState(false);


  return (
    
    <motion.section
      className="bg-eryndra-hero bg-cover bg-center text-center  py-60 z-10 relative"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      
    >
        
      
      <h1 className="font-title text-5xl md:text-8xl  mb-4  tracking-widest text-shadow-lg">
        eRYNDRA eVeNTOS
      </h1>
      <p className="text-lg md:text-2xl  text-shadow-DEFAULT">
        Tu historia, hecha Magia.
      </p>
      <div className="!pl-0 !ml-0 absolute bottom--1 left-0 w-full h-32 bg-gradient-to-b from-transparent to-eryndra-forest opacity-100 pointer-events-none z-10" />
    </motion.section>
  );
}